import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getRoomByID,
  getRoomDetails,
  getRoomDetailsByPg,
  getTenant,
  getTenantByRoom,
  updateRoom,
} from "./apiService";
import { useAuth } from "./auth";

const EditRoom = () => {
  const [roomname, setRoomname] = useState("");
  const [beds, setBeds] = useState("");
  const [errors, setErrors] = useState({});
  const [roomdetails, setRoomdetails] = useState([]);
  const [tenantdetails, setTenantdetails] = useState([]);
  const { pgid, roomid } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getRoomByID(roomid)
      .then((res) => {
        // console.log(res);
        setRoomname(res.roomname);
        setBeds(res.beds);
      })
      .catch((e) => console.log(e));

    getRoomDetailsByPg(pgid).then((res) => {
      setRoomdetails(res);
    });
    getTenantByRoom(roomid).then((res) => {
      setTenantdetails(res);
    });
  }, [roomid]);

  // console.log(userid);

  const handleRoomEditSubmit = () => {
    let errors = {};
    if (!roomname) errors.roomname = "Room name is required";
    if (!beds) errors.beds = "Enter valid no here";

    roomdetails.forEach((room) => {
      if (room.roomname === roomname && room.id !== roomid) {
        errors.roomname = "Room Name already taken";
        // console.log(errors.username);
      }
      return errors;
    });

    const fguests = tenantdetails.filter((tenant) => {
      return tenant.roomNo === roomid;
    });

    if (Object.keys(fguests).length > beds) {
      alert(
        "Guests were using the beds. Please delete/vacate a guest before reducing the bed count...!!"
      );
      errors.beds = "Not able to decrease the no of beds";
      // return errors;
    }

    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      const room = {
        roomname: roomname,
        beds: beds,
        pgname: pgid,
      };
      // setUser(user1);

      updateRoom(room, roomid);

      setRoomname("");
      setBeds("");
      navigate("/Dashboard/MyPGDetails");
    }
  };
  return (
    <div className="container">
      <div className="header">Edit ROOM</div>
      <div className="label">
        Room Name:
        <input
          type="text"
          className="inputbox"
          name="roomname"
          defaultValue={roomname}
          // value={pgdata.pgname}
          onChange={(e) => setRoomname(e.target.value)}
        />
        {errors.roomname ? (
          <div className="errortext">{errors.roomname}</div>
        ) : null}
      </div>

      <div className="label">
        No.of Beds:
        <input
          type="text"
          className="inputbox"
          name="beds"
          defaultValue={beds}
          // value={rooms}
          onChange={(e) => setBeds(e.target.value)}
        />
        {errors.beds ? <div className="errortext">{errors.beds}</div> : null}
      </div>
      <input
        type="submit"
        className="btn-cls"
        value="Submit"
        onClick={handleRoomEditSubmit}
      />
    </div>
  );
};

export default EditRoom;
